(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGBlogV1 extends HTMLElement {
      connectedCallback() {
        this.formatNumbers();
      }

      formatNumbers() {
        const locale = document.documentElement.lang || navigator.language || 'en-US';
        const formatter = new Intl.NumberFormat(locale);

        this.querySelectorAll('[data-yg-number]').forEach((node) => {
          const value = Number(node.getAttribute('data-yg-number'));

          if (!Number.isNaN(value)) {
            node.textContent = formatter.format(value);
          }
        });
      }
    }

    const boot = () => {
      if (!window.customElements.get('yg-blog-v1')) {
        window.customElements.define('yg-blog-v1', YGBlogV1);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-download-section"] && !Shopify.designMode) return;
  try {
    
  class YGDownloadSection extends HTMLElement {
    constructor() {
      super();
      this.handleFilterToggle = this.handleFilterToggle.bind(this);
      this.handleFilterSelect = this.handleFilterSelect.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleEscKey = this.handleEscKey.bind(this);
      this.boundSwiperScrollers = new Map();
      this.handleWindowResize = this.syncDownloadScrollMasks.bind(this);
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      this.$filterToggle = this.querySelector('[data-filter-toggle]');
      this.$filterMenu = this.querySelector('[data-filter-menu]');
      this.$filterValue = this.querySelector('[data-filter-value]');
      this.$filterOptions = Array.from(this.querySelectorAll('.yg-download__filter-option'));
      this.$groups = Array.from(this.querySelectorAll('.yg-download__group'));

      if (this.$filterToggle) {
        this.$filterToggle.addEventListener('click', this.handleFilterToggle);
      }
      if (this.$filterMenu) {
        this.$filterMenu.addEventListener('click', this.handleFilterSelect);
      }

      document.addEventListener('click', this.handleOutsideClick);
      document.addEventListener('keydown', this.handleEscKey);
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      window.addEventListener('resize', this.handleWindowResize);

      this._closeTimer = setTimeout(() => {
        this.querySelectorAll('yg-dropdown[open]').forEach(d => d.closeDropdown());
      }, 100);

      this.syncDownloadScrollMasks();
      requestAnimationFrame(() => this.syncDownloadScrollMasks());
    }

    disconnectedCallback() {
      this._connected = false;
      clearTimeout(this._closeTimer);
      if (this.$filterToggle) {
        this.$filterToggle.removeEventListener('click', this.handleFilterToggle);
      }
      if (this.$filterMenu) {
        this.$filterMenu.removeEventListener('click', this.handleFilterSelect);
      }
      document.removeEventListener('click', this.handleOutsideClick);
      document.removeEventListener('keydown', this.handleEscKey);
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      window.removeEventListener('resize', this.handleWindowResize);

      this.boundSwiperScrollers.forEach((cleanup) => cleanup());
      this.boundSwiperScrollers.clear();
    }

    handleFilterToggle(e) {
      e.stopPropagation();
      if (!this.$filterMenu || !this.$filterToggle) return;
      const isOpen = this.$filterMenu.classList.toggle('is-open');
      this.$filterToggle.setAttribute('aria-expanded', String(isOpen));
    }

    handleFilterSelect(e) {
      const option = e.target.closest('.yg-download__filter-option');
      if (!option) return;
      const value = option.dataset.filterValue;

      if (this.$filterValue) {
        this.$filterValue.textContent = option.textContent;
      }
      this.closeFilterMenu();

      this.$filterOptions.forEach(opt => {
        opt.classList.toggle('is-active', opt === option);
      });

      if (value === 'all') {
        this.$groups.forEach(group => { group.hidden = false; });
      } else {
        this.$groups.forEach(group => {
          group.hidden = group.dataset.group !== value;
        });
      }

      requestAnimationFrame(() => {
        this.querySelectorAll('yg-swiper').forEach(sw => {
          if (sw.swiper && !sw.closest('[hidden]')) {
            sw.swiper.update();
          }
        });

        this.syncDownloadScrollMasks();
      });
    }

    handleDropdownOpen() {
      requestAnimationFrame(() => {
        this.syncDownloadScrollMasks();
      });
    }

    bindDownloadSwiper(swiperEl) {
      if (this.boundSwiperScrollers.has(swiperEl)) {
        this.updateDownloadScrollMask(swiperEl);
        return;
      }

      const dropdownContent = swiperEl.closest('.yg-dropdown-content');
      if (!dropdownContent) return;

      const queueUpdate = () => requestAnimationFrame(() => this.updateDownloadScrollMask(swiperEl));
      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(queueUpdate) : null;

      swiperEl.addEventListener('scroll', queueUpdate, { passive: true });
      resizeObserver?.observe(swiperEl);

      Array.from(swiperEl.children).forEach((child) => {
        resizeObserver?.observe(child);
      });

      this.boundSwiperScrollers.set(swiperEl, () => {
        swiperEl.removeEventListener('scroll', queueUpdate);
        resizeObserver?.disconnect();
      });

      queueUpdate();
    }

    updateDownloadScrollMask(swiperEl) {
      const dropdownContent = swiperEl.closest('.yg-dropdown-content');
      if (!dropdownContent) return;

      const maxScrollLeft = Math.max(swiperEl.scrollWidth - swiperEl.clientWidth, 0);
      const tolerance = 1;

      dropdownContent.classList.toggle('yg-has-scroll-left', swiperEl.scrollLeft > tolerance);
      dropdownContent.classList.toggle(
        'yg-has-scroll-right',
        maxScrollLeft > tolerance && swiperEl.scrollLeft < maxScrollLeft - tolerance
      );
    }

    syncDownloadScrollMasks() {
      const swiperEls = new Set(this.querySelectorAll('.yg-download__cards-swiper'));

      this.boundSwiperScrollers.forEach((cleanup, swiperEl) => {
        if (!swiperEls.has(swiperEl)) {
          cleanup();
          this.boundSwiperScrollers.delete(swiperEl);
        }
      });

      swiperEls.forEach((swiperEl) => this.bindDownloadSwiper(swiperEl));
    }

    closeFilterMenu() {
      if (this.$filterMenu) this.$filterMenu.classList.remove('is-open');
      if (this.$filterToggle) this.$filterToggle.setAttribute('aria-expanded', 'false');
    }

    handleOutsideClick(e) {
      if (!this.contains(e.target)) this.closeFilterMenu();
    }

    handleEscKey(e) {
      if (e.key === 'Escape') this.closeFilterMenu();
    }
  }

  if (!window.customElements.get('yg-download-section')) {
    window.customElements.define('yg-download-section', YGDownloadSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      this.initializeDefaultStep();
    }

    disconnectedCallback() {
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
    }

    handleDropdownOpen(event) {
      if (event.detail?.id) {
        this.currentStep(event.detail.id);
      }
    }

    handleProgressEnd(event) {
      if (event.detail?.id) {
        this.nextStep(event.detail.id);
      }
    }

    initializeDefaultStep() {
      requestAnimationFrame(() => {
        const activeItem = this.querySelector('.yg-process-steps-item[open]') || this.$sectionEl['accordionList'][0];
        const activeId = activeItem?.getAttribute('data-id');

        if (!activeId) {
          return;
        }

        if (typeof activeItem.openDropdown === 'function' && !activeItem.hasAttribute('open')) {
          activeItem.openDropdown();
          return;
        }

        this.currentStep(activeId);
      });
    }

    nextStep(id) {
      if (!this.isActiveStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.playVideo(id);
      this.startProgressForId(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    isActiveStep(id) {
      return this.$sectionEl['accordionList'][this.currentStepIndex]?.getAttribute('data-id') === id;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          const video = this.getVideoById(id);
          if (video) {
            item.setVideo(video);
          }
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (typeof videoEl?.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (typeof videoEl?.playVideo === 'function') {
        videoEl.playVideo();
        return;
      }

      if (videoEl) {
        customElements.whenDefined('yg-video').then(() => {
          if (this.isActiveStep(id) && typeof videoEl.playVideo === 'function') {
            videoEl.playVideo();
          }
        });
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-specifications"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGSpec extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.yg-specs-toggle');

      if (!this.toggle) return;

      this.specItems = this.querySelectorAll('.spec-item');
      this.visibleCount = 5;

      // 不足 5 个隐藏按钮
      if (this.specItems.length <= this.visibleCount) {
        this.toggle.style.display = 'none';
        return;
      }

      // 默认隐藏第 6 个及以后
      for (let i = this.visibleCount; i < this.specItems.length; i++) {
        this.specItems[i].classList.add('spec-item-hidden');
      }

      this.toggle.addEventListener('click', () => {
        this.handleToggle();
      });
    }

    handleToggle() {
      const isExpanded = this.toggle.classList.contains('expanded');

      if (isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.toggle.classList.remove('collapsed');
      this.toggle.classList.add('expanded');
      this.toggle.setAttribute('aria-expanded', 'true');

      const text = this.toggle.querySelector('span');
      if (text) {
        text.textContent = 'Show less';
      }

      for (let i = this.visibleCount; i < this.specItems.length; i++) {
        this.specItems[i].classList.add('show');
      }
    }

    collapse() {
      this.toggle.classList.remove('expanded');
      this.toggle.classList.add('collapsed');
      this.toggle.setAttribute('aria-expanded', 'false');

      const text = this.toggle.querySelector('span');
      if (text) {
        text.textContent = 'Show more';
      }

      for (let i = this.visibleCount; i < this.specItems.length; i++) {
        this.specItems[i].classList.remove('show');
      }
    }
  }

  if (!customElements.get('yg-spec')) {
    customElements.define('yg-spec', YGSpec);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTabsScroll = this.updateTabsScrollMaskState.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsScrollBox: this.querySelector('[data-tabs-scroll-box]'),
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        this.sectionElements.tabsScrollContainer?.addEventListener('scroll', this.handleTabsScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        this.sectionElements.tabsScrollContainer?.removeEventListener('scroll', this.handleTabsScroll);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = true;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();
        this.updateTabsScrollMaskState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollBox = this.sectionElements.tabsScrollBox;
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollBox || !scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
        this.updateTabsScrollMaskState();
      }

      updateTabsScrollMaskState() {
        const scrollBox = this.sectionElements.tabsScrollBox;
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollBox || !scrollContainer) {
          return;
        }

        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const tolerance = 1;

        scrollBox.classList.toggle('yg-has-scroll-left', scrollContainer.scrollLeft > tolerance);
        scrollBox.classList.toggle(
          'yg-has-scroll-right',
          maxScrollLeft > tolerance && scrollContainer.scrollLeft < maxScrollLeft - tolerance
        );
      }

      updateIndicator() {
        const tabsTrack = this.sectionElements.tabsTrack;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!tabsTrack || !activeTab) {
          return;
        }

        tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
        tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGVideoTabs extends HTMLElement {
    constructor() {
      super();
      this.currentTabKey = 'all';
      this.currentPage = 1;
      this.itemsPerPage = 1;
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        cardsPanel: this.querySelector('[data-cards]'),
        cards: Array.from(this.querySelectorAll('[data-card]')),
        pagination: this.querySelector('[data-pagination]'),
        paginationPages: this.querySelector('[data-pagination-pages]'),
        paginationPrev: this.querySelector('[data-page-action="prev"]'),
        paginationNext: this.querySelector('[data-page-action="next"]'),
        tabButtons: Array.from(this.querySelectorAll('[data-tab-button]')),
        tabTrack: this.querySelector('[data-tabs-track]'),
        tabsScroll: this.querySelector('[data-tabs-scroll]'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.itemsPerPage = this.getItemsPerPage();

      this.addEventListener('click', this.handleClick);
      this.sectionElements.tabTrack?.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.handleResize);

      this.updateTabsOverflow();
      this.filterAndPaginate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.sectionElements.tabTrack?.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.initialized = false;
    }

    getItemsPerPage() {
      const desktopItemsPerPage = Number.parseInt(this.dataset.itemsPerPage || '9', 10);
      const mobileItemsPerPage = Number.parseInt(this.dataset.itemsPerPageMobile || '4', 10);

      if (window.matchMedia('(max-width: 699px)').matches) {
        return mobileItemsPerPage;
      }

      return desktopItemsPerPage;
    }

    handleClick(event) {
      const tabButton = event.target.closest('[data-tab-button]');
      if (tabButton && this.contains(tabButton)) {
        this.setTab(tabButton.dataset.tabKey || 'all');
        return;
      }

      const pageButton = event.target.closest('[data-page-button]');
      if (pageButton && this.contains(pageButton)) {
        const page = Number.parseInt(pageButton.dataset.pageButton || '1', 10);
        this.setPage(page);
        return;
      }

      const pageActionButton = event.target.closest('[data-page-action]');
      if (pageActionButton && this.contains(pageActionButton)) {
        if (pageActionButton.dataset.pageAction === 'prev') {
          this.setPage(this.currentPage - 1);
        } else {
          this.setPage(this.currentPage + 1);
        }
      }
    }

    handleKeydown(event) {
      const activeIndex = this.sectionElements.tabButtons.findIndex((button) => button.dataset.tabKey === this.currentTabKey);
      let nextIndex = activeIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = Math.min(activeIndex + 1, this.sectionElements.tabButtons.length - 1);
      } else if (event.key === 'ArrowLeft') {
        nextIndex = Math.max(activeIndex - 1, 0);
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.sectionElements.tabButtons.length - 1;
      } else {
        return;
      }

      event.preventDefault();

      const nextButton = this.sectionElements.tabButtons[nextIndex];
      if (!nextButton) {
        return;
      }

      this.setTab(nextButton.dataset.tabKey || 'all', {
        shouldFocus: true,
      });
    }

    handleResize() {
      const nextItemsPerPage = this.getItemsPerPage();
      if (nextItemsPerPage !== this.itemsPerPage) {
        this.itemsPerPage = nextItemsPerPage;
        this.currentPage = 1;
        this.filterAndPaginate();
      }

      this.updateTabsOverflow();
    }

    setTab(tabKey, options = {}) {
      const normalizedTabKey = tabKey || 'all';
      const shouldFocus = options.shouldFocus || false;

      if (normalizedTabKey === this.currentTabKey && !shouldFocus) {
        return;
      }

      this.currentTabKey = normalizedTabKey;
      this.currentPage = 1;
      this.updateTabButtons();
      this.filterAndPaginate();
      this.scrollActiveTabIntoView();

      if (shouldFocus) {
        const activeButton = this.sectionElements.tabButtons.find((button) => button.dataset.tabKey === this.currentTabKey);
        activeButton?.focus();
      }
    }

    setPage(page) {
      const nextPage = Math.max(1, page);
      if (nextPage === this.currentPage) {
        return;
      }

      this.currentPage = nextPage;
      this.filterAndPaginate();
      this.scrollCardsIntoView();
    }

    updateTabButtons() {
      this.sectionElements.tabButtons.forEach((button) => {
        const isActive = (button.dataset.tabKey || 'all') === this.currentTabKey;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    updateTabsOverflow() {
      const tabsScroll = this.sectionElements.tabsScroll;
      const tabTrack = this.sectionElements.tabTrack;

      if (!tabsScroll || !tabTrack) {
        return;
      }

      tabsScroll.classList.toggle('is-overflowing', tabTrack.scrollWidth > tabsScroll.clientWidth + 1);
    }

    scrollActiveTabIntoView() {
      const activeButton = this.sectionElements.tabButtons.find((button) => button.dataset.tabKey === this.currentTabKey);
      activeButton?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }

    scrollCardsIntoView() {
      this.sectionElements.cardsPanel?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

    filterAndPaginate() {
      const filteredCards = this.sectionElements.cards.filter((card) => {
        if (this.currentTabKey === 'all') {
          return true;
        }

        return (card.dataset.tabKey || '') === this.currentTabKey;
      });

      const totalPages = Math.max(1, Math.ceil(filteredCards.length / this.itemsPerPage));
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }

      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const visibleCards = filteredCards.slice(startIndex, endIndex);
      const visibleCardsSet = new Set(visibleCards);

      this.sectionElements.cards.forEach((card) => {
        const isVisible = visibleCardsSet.has(card);
        card.hidden = !isVisible;
        card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });

      this.renderPagination(totalPages);
    }

    renderPagination(totalPages) {
      const { pagination, paginationPages, paginationPrev, paginationNext } = this.sectionElements;

      if (!pagination || !paginationPages || !paginationPrev || !paginationNext) {
        return;
      }

      pagination.hidden = totalPages <= 1;
      paginationPrev.disabled = this.currentPage === 1;
      paginationNext.disabled = this.currentPage === totalPages;
      paginationPages.innerHTML = '';

      for (let page = 1; page <= totalPages; page += 1) {
        const pageButton = document.createElement('button');
        pageButton.type = 'button';
        pageButton.className = 'yg-video-tabs__page radius-xs text-sm bold';
        pageButton.dataset.pageButton = String(page);
        pageButton.textContent = String(page);

        if (page === this.currentPage) {
          pageButton.classList.add('is-active');
          pageButton.setAttribute('aria-current', 'page');
        }

        paginationPages.appendChild(pageButton);
      }
    }
  }

  if (!window.customElements.get('yg-video-tabs')) {
    window.customElements.define('yg-video-tabs', YGVideoTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
